/*
 * Detail card for a single property, shown when a map marker is selected. Sized to sit
 * inside a floating map panel, so it scrolls internally rather than growing the panel.
 */

.card {
    display: flex;
    flex-direction: column;
    /* always mounted inside a height-capped flex column panel, so the body scrolls
       rather than the panel growing past the map */
    flex: 1 1 auto;
    min-height: 0;
}

.header {
    display: flex;
    align-items: flex-start;
    column-gap: 10px;
    padding: 12px 14px 10px;
}

.thumbnail {
    flex-shrink: 0;
    width: 52px;
    height: 52px;
    border-radius: 7px;
    object-fit: cover;
    border: 1px solid var(--map-hairline);
}

.heading {
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    row-gap: 2px;
}

.name {
    color: var(--map-ink);
    overflow-wrap: anywhere;
}

.address {
    color: var(--map-muted);
    line-height: 1.4;
}

.badge {
    flex-shrink: 0;
    white-space: nowrap;
    font-weight: 600;
    color: var(--map-accent-ink);
    /* nudged onto the name's baseline, which sits below the icon button's box */
    margin-top: 2px;
}

.close {
    flex-shrink: 0;
    /* pulled into the header padding so it lines up with the card's edge */
    margin: -4px -6px 0 0;
}

.chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 0 14px 10px;
}

.statusChip {
    display: inline-flex;
    align-items: center;
    column-gap: 5px;
    padding: 3px 8px;
    border-radius: 999px;
    border: 1px solid var(--map-hairline);
    background-color: rgba(17, 24, 39, 0.04);
    color: var(--map-muted);
    font-size: 11.5px;
    font-weight: 600;
}

.statusChipVacant {
    border-color: rgba(16, 185, 129, 0.4);
    background-color: rgba(16, 185, 129, 0.1);
    color: var(--map-accent-ink);
}

.statusChipCapped {
    border-color: rgba(217, 119, 6, 0.35);
    background-color: rgba(217, 119, 6, 0.1);
    color: var(--map-warn-ink);
}

.statusDot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: currentcolor;
}

.body {
    min-height: 0;
    overflow-y: auto;
    padding: 0 14px 12px;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
}

.rows {
    display: grid;
    grid-template-columns: auto 1fr;
    column-gap: 12px;
    row-gap: 6px;
    align-items: baseline;
}

.rowLabel {
    color: var(--map-muted);
}

.rowValue {
    color: var(--map-ink);
    text-align: right;
    overflow-wrap: anywhere;
}

/* lease ending within two weeks — the amber of the anchor/warn family, not an error */
.rowValueHighlighted {
    color: var(--map-warn-ink);
    font-weight: 600;
}

.section {
    display: flex;
    flex-direction: column;
    row-gap: 6px;
    padding-top: 10px;
    border-top: 1px solid var(--map-hairline);
}

.sectionLabel {
    color: var(--map-muted);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
}

.links {
    display: flex;
    flex-direction: column;
    row-gap: 5px;
    align-items: flex-start;
}

.link {
    display: inline-flex;
    align-items: center;
    column-gap: 5px;
}

.notes {
    color: var(--map-muted);
    line-height: 1.5;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}

.empty {
    color: var(--map-muted);
}

.actions {
    display: flex;
    align-items: center;
    column-gap: 8px;
    padding: 10px 14px;
    border-top: 1px solid var(--map-hairline);
    background-color: var(--map-surface);
}

.actionsSpacer {
    flex: 1;
}
